import { startCase } from 'lodash';

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'snLabel',
})
export class SnLabelPipe implements PipeTransform {
  public transform(label: string): string {
    return startCase(label);
  }
}
